import { InjectionToken } from '@angular/core';
import { Environment } from '@fitscovery/common/environments';

export const APP_ENVIRONMENT = new InjectionToken<Environment>('booking.data-access.environment');
